import { LayerKey } from '@festina-life/api'
import type { Optional } from '@festina-life/core'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'

import { configurationItem, scratchpad } from '../../system/paths'
import { useNavigationParams } from '../../system/useNavigationParams'
import { useOperationsContext } from '../../workspace/operationsContext'
import type { TabLink } from './types'
import { useCurrentPathAsTabLink } from './useCurrentPathAsTabLink'

type Props = {
  visibleTabLinks: Optional<TabLink[]>
}

export const useEnsureNavigationToActivePath = ({ visibleTabLinks }: Props) => {
  const navigate = useNavigate()
  const currentPathAsLink = useCurrentPathAsTabLink()
  const { branch, server } = useNavigationParams()
  const { workspaceKey } = useOperationsContext()

  useEffect(
    function ensureNavigationToActivePath() {
      const activeLink = visibleTabLinks?.find((tabLink) => tabLink.isActive)

      if (activeLink && !currentPathAsLink) {
        void navigate(
          activeLink.variant === 'scratchpad'
            ? scratchpad({
                server,
                workspaceName: workspaceKey?.name,
                branch,
                layer: new LayerKey(activeLink.layer),
                block: activeLink.block,
              })
            : configurationItem({
                server,
                branch,
                layer: new LayerKey(activeLink.layer),
                workspaceName: workspaceKey?.name,
                itemId: activeLink.id,
                type: activeLink.variant,
                block: activeLink.block,
              }),
        )
      }
    },
    [
      branch,
      currentPathAsLink,
      navigate,
      server,
      visibleTabLinks,
      workspaceKey?.name,
    ],
  )
}
